/**
 * Service frontend para "Probar canal" del admin (ADR-027.3, prompt 0658c).
 *
 * Wrapper tipado sobre `request()` que invoca POST /api/v1/admin/notify-config/test/:canal.
 * El endpoint envia 1 mensaje TEST_PING al admin actual (req.userId) bypaseando modoSandbox
 * (forceSend=true en backend) y persiste en NTF.workflow_notif_envio (audit trail).
 *
 * Rate limit 10/min/IP (notifyTestPingLimiter en backend).
 */

import { request } from '../../shared/services/api';

/** Canal a probar. IN_APP no se expone en UI Bloque 2 (no requiere config admin). */
export type CanalTestPing = 'EMAIL' | 'TEAMS' | 'SLACK' | 'IN_APP';

/** Locale del test ping. Si se omite, backend usa usuario.idiomaPreferido o 'es'. */
export type TestPingLocale = 'es' | 'en' | 'zh';

/** Discriminated union — espejo exacto de EnvioResult del backend. */
export type EnvioResult =
  | { sent: true; provider: string; messageIds: string[] }
  | {
      sent: false;
      reason: 'NO_PROVIDER_CONFIGURED' | 'PROVIDER_ERROR' | 'SANDBOX_MODE' | 'NO_DESTINATARIOS';
      detail?: string;
    };

/** Mapeo canal UI (lowercase) -> canal backend (UPPERCASE). */
export const canalConfigToTestPing: Record<'mail' | 'teams' | 'slack', CanalTestPing> = {
  mail: 'EMAIL',
  teams: 'TEAMS',
  slack: 'SLACK',
};

/**
 * POST /api/v1/admin/notify-config/test/:canal
 * Envia 1 mensaje TEST_PING al admin actual.
 * NUNCA lanza errores HTTP -> el caller debe inspeccionar `result.sent`.
 */
export async function testCanal(
  canal: CanalTestPing,
  locale?: TestPingLocale,
): Promise<EnvioResult> {
  const res = await request<{ data: EnvioResult }>(`/admin/notify-config/test/${canal}`, {
    method: 'POST',
    body: JSON.stringify(locale ? { locale } : {}),
  });
  return res.data;
}
